import classNames from 'classnames';
import type { LocaleResources } from 'locales';
import React from 'react';
import { NextImage } from 'src/components/shared/elements/NextImage';
import { BaseButton } from 'src/components/shared/elements/buttons/BaseButton';
import { CommonModal } from 'src/components/shared/elements/modals/CommonModal';
import { ModalIcon, iconType } from 'src/components/shared/elements/modals/ModalIcon';
import { toJSX } from 'src/utils/toJSXHelper';

type Props = {
  buttonText: string;
  localeResources: LocaleResources;
  imagePath: string;
  onButtonClick: () => void;
  closeModal: () => void;
  isCampaignPage: boolean;
  step: 1 | 2;
};

export const Presenter: React.FC<Props> = ({
  buttonText,
  localeResources,
  imagePath,
  onButtonClick,
  closeModal,
  isCampaignPage,
  step
}) => {
  const renderContent = () => (
    <div className="text-center my-5">
      <ModalIcon type={isCampaignPage ? iconType.INFO : iconType.COUPON} />
      {isCampaignPage && <p className="my-5 font-semibold">{localeResources.yamazakiGift.modal.title}</p>}
      <div className="mb-5 px-10 text-left">
        {toJSX(localeResources.issuedCoupon.couponHasBeenIssued('font-semibold'))}
      </div>
      <NextImage src={imagePath} width={320} height={367} alt="screenShot" />
    </div>
  );

  return (
    <CommonModal
      closeModal={closeModal}
      fixedElement={<BaseButton text={buttonText} width={240} onClick={onButtonClick} />}
    >
      {isCampaignPage ? (
        <div
          className={classNames(
            'relative w-[310px] h-[500px] mx-auto overflow-hidden',
            'semiLg:w-[358px] semiLg:h-[600px]'
          )}
        >
          <div
            className="flex transition-transform duration-500 w-full h-full"
            style={{ transform: `translateX(-${(step - 1) * 100}%)` }}
          >
            {[1, 2].map((currentStep) => (
              <div
                key={currentStep}
                className={classNames(
                  'w-[310px] shrink-0 h-full overflow-scroll pb-5',
                  'semiLg:w-[358px] semiLg:h-[600px]'
                )}
              >
                {renderContent()}
              </div>
            ))}
          </div>
        </div>
      ) : (
        renderContent()
      )}
    </CommonModal>
  );
};
